export enum Events {
  SEARCH_FORM_SUBMIT = 'SearchFormSubmit',
  SEARCH_RESULT = 'SearchResult',
  START_TOLL_ROADS_SEARCH = 'StartTollRoadsSearch',
  EMAIL_RESULT = 'EmailResult',
  GIBDD_RESULT = 'GibddResult',
  SUBSCRIBE = 'Subscribe',
  PAYMENT_SUCCESS = 'PaymentSuccess',
  PAYMENT_FAIL = 'PaymentFail',
  PAYER_INFO_SUBMIT = 'PayerInfoSubmit',
  PAYMENT_VALID_CARD_FILLED = 'PaymentValidCardFilled',
  TOGGLE = 'Toggle',
  SEARCH_PARSE_DATA_ERROR = 'ParseDataError',
  SEARCH_SHOW_CAPTCHA = 'ShowCaptcha',
  SEARCH_SHOW_CAPTCHA_POPUP = 'ShowCaptchaPopup',
  SEARCH_HIDE_CAPTCHA_POPUP = 'HideCaptchaPopup',
  DELAY_LOADING_DATA = 'DelayLoading',
  HIDE_BUTTON_NEXT_PAGE = 'HideBtnNextPage',
  FNS_LK_LOADED = 'FnsLkAccrualsLoaded',
  PUSH_SUBSCRIBE = 'PushSubscribe',
  PAYMENT_FRAME_LOADED = 'PaymentFrameLoaded',
  LAST_ACTIVITY = 'LastActivity',
  FORM_DATA_LOADED = 'FormDataLoaded',
  FORM_DATA_INVALID = 'FormDataInvalid',
  DATA_ERROR_FROM_VALIDATION = 'DataErrorFormValidation'
}
